import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { JSONRpc } from '../service-jsonrpc';
import { Observable, of } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root',
})
export class updateDossierService {
    constructor(
        private http: HttpClient
    ) {}
    
    callPOSTJSONRpc(url, rpcMethod): Observable<any> {
        return this.http.post<JSONRpc>(url + '?' + rpcMethod.method, rpcMethod);
    }
    
    updateDateModificationDossier(dossier, date): Observable<any> {
        let rpcMethod = new JSONRpc({
            jsonrpc : "2.0",
            method:"webservice.dossier:updateDateModificationDossier",
            params: {
                dossier : dossier,
                date : date
            }
        });
        return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
    }

    setDossierLabel(dossierId, label): Observable<any> {
        let rpcMethod = new JSONRpc({
            jsonrpc : "2.0",
            method:"webservice.dossier:setDossierLabel",
            params: {
                id : dossierId,
                label : label
            }
        });
        return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
    }
}